import React, { useState } from "react";
import { processData } from "../../static/data";

const Process = () => {
  const [activeTab, setActiveTab] = useState(1);

  return (
    <section className="process section" id="process">
      <div className="process__container container">
        <div className="process__header">
          <h2 className="section__title">How I Get It Done Smoothly</h2>
          <p className="section__subtitle">
            From start to finish, I handle the process so you can relax and
            watch your idea come to life.
          </p>
        </div>

        <div className="process__cards-wrapper">
          {processData.map((item) => (
            <div
              key={item.id}
              className={`process__card ${activeTab === item.id ? "process__card--active" : ""}`}
              onClick={() => setActiveTab(item.id)}
            >
              <div className="process__card-content">
                <span className="process__step-badge">{item.step}</span>

                {activeTab === item.id ? (
                  <div className="process__active-info">
                    <h3 className="process__title">{item.title}</h3>
                    <p className="process__description">{item.description}</p>
                  </div>
                ) : (
                  <div className="process__inactive-info">
                    <h3 className="process__title-vertical">{item.title}</h3>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
